module.exports = __webpack_public_path__ + "img/appAsset--log-ax.eb29fdb8.svg";